webpackJsonp([149058690096730],{

/***/ 2143:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"MessageSender","kind":"UNION","type":"OBJECT","fields":null,"description":"A sender of a message, either a provider, client, rdvm or an associate","enumValues":null,"possibleTypes":[{"kind":"OBJECT","name":"Client","ofType":null},{"kind":"OBJECT","name":"Coowner","ofType":null},{"kind":"OBJECT","name":"Provider","ofType":null},{"kind":"OBJECT","name":"Rdvm","ofType":null}]}}

/***/ })

});


// WEBPACK FOOTER //
// path---union-message-sender-b38d96b6e35db4add09a.js